import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
// import { ViewerModule } from 'ng2-adsk-forge-viewer';

import { MyApp } from './app.component';
import { LoginPageModule } from '../pages/login/login.module';
import { HomePageModule } from '../pages/home/home.module';
import { UsersPageModule } from '../pages/users/users.module';
import { UploadPageModule } from '../pages/upload/upload.module';
import { BundlePageModule } from '../pages/bundle/bundle.module';
import { ActivityPageModule } from '../pages/activity/activity.module';
import { ViewerPageModule } from '../pages/viewer/viewer.module';
import { ModalsEngineselectorPageModule } from '../pages/modals-engineselector/modals-engineselector.module';
import { ModalsUserseditPageModule } from '../pages/modals-usersedit/modals-usersedit.module';
import { RestProvider } from '../providers/rest/rest';
import { DataProvider } from '../providers/data/data';
import { HttpClientModule } from '@angular/common/http';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

@NgModule({
  declarations: [
    MyApp
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    // ViewerModule,
    LoginPageModule,
    HomePageModule,
    UsersPageModule,
    UploadPageModule,
    BundlePageModule,
    ActivityPageModule,
    NgxDatatableModule,
    ViewerPageModule,
    ModalsEngineselectorPageModule,
    ModalsUserseditPageModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    RestProvider,
    DataProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts